// Overdue/Approaching status utilities
// A work order is "overdue" if end_datetime has passed and status is not final
// A work order is "approaching" if end_datetime is within next 24 hours

const FINAL_STATUSES = ["Completed", "Cancelled"];

export const getOverdueStatus = (workOrder) => {
  if (!workOrder || !workOrder.end_datetime) return "none";
  if (FINAL_STATUSES.includes(workOrder.status)) return "none";

  const now = new Date();
  const endDate = new Date(workOrder.end_datetime);
  const diffMs = endDate.getTime() - now.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffMs < 0) return "overdue";
  if (diffHours <= 24) return "approaching";
  return "none";
};

export const getTimeRemaining = (workOrder) => {
  if (!workOrder || !workOrder.end_datetime) return "";
  const now = new Date();
  const endDate = new Date(workOrder.end_datetime);
  const diffMs = endDate.getTime() - now.getTime();

  const absMs = Math.abs(diffMs);
  const days = Math.floor(absMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((absMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((absMs % (1000 * 60 * 60)) / (1000 * 60));

  let str = "";
  if (days > 0) str = `${days}d ${hours}h`;
  else if (hours > 0) str = `${hours}h ${minutes}m`;
  else str = `${minutes}m`;

  return diffMs < 0 ? `Overdue by ${str}` : `${str} remaining`;
};

export const countOverdue = (workOrders) => {
  let overdue = 0;
  let approaching = 0;

  workOrders.forEach((wo) => {
    const status = getOverdueStatus(wo);
    if (status === "overdue") overdue++;
    if (status === "approaching") approaching++;
  });

  return { overdue, approaching };
};
